import { z } from "zod";
import { ZProjectNo } from "./foundationSchema";
import { ZCreateViewPresetInput } from "./viewPreset.schema";
import { ZCreateSharedViewInput } from "./sharedView.schema";
// The OpenAPI adapter requires an object at the root; variants live inside data.
export const ZCreateViewInput = z.object({
    projectNo: ZProjectNo,
    data: z.discriminatedUnion("kind", [
        ZCreateViewPresetInput.omit({ projectNo: true }).extend({ kind: z.literal("preset") }),
        ZCreateSharedViewInput.omit({ projectNo: true }).extend({ kind: z.literal("snapshot") }),
    ]),
});
